import { render, staticRenderFns } from "./MyAccountUploadDetails.vue?vue&type=template&id=6b1791a8&scoped=true"
import script from "./MyAccountUploadDetails.vue?vue&type=script&lang=js"
export * from "./MyAccountUploadDetails.vue?vue&type=script&lang=js"
import style0 from "./MyAccountUploadDetails.vue?vue&type=style&index=0&id=6b1791a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1791a8",
  null
  
)

export default component.exports